import { useEffect, useState } from 'react'
import { dueStateOf, MAX_TIMEOUT_MS, nextDueStateChange, type DueState } from '../utils/due-date'

/** Where a due date stands, moving on by itself at the midnight it falls due on and when it passes. */
export function useDueState(scheduledAt: Date | undefined): DueState | undefined {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    const next = nextDueStateChange(scheduledAt)
    if (next == null) return
    const timer = setTimeout(() => setTick((value) => value + 1), Math.min(next - Date.now(), MAX_TIMEOUT_MS))
    return () => clearTimeout(timer)
  }, [scheduledAt, tick])

  return dueStateOf(scheduledAt)
}
